<template>
  <v-container fluid fill-height class="grey lighten-3 pl-2 pr-2 pt-2">
    <v-layout row wrap>
      <v-flex xs12>
        <div class="mt-2 mb-2 ob-section-title-and-tabs">
          <h1 class="headline ob-section-title pr-4 primary--text d-flex">
            <v-avatar class="ob-no-grow-or-shrink mr-2" :class="{ 'ob-rotate': loading }" size="36">
              <img src="/img/tud_group_round_transparent.png" alt="TUD Group company logo">
            </v-avatar>
            {{ translateUI(label, lang) }}
            <v-spacer></v-spacer>
          </h1>
          <v-tabs
            v-if="tabs.length"
            hide-slider
            color="transparent"
            slider-color="accent"
            class="ml-2 ob-section-tabs"
            show-arrows
            v-model="selectedTabIdentifier"
            :key="tabsUpdate">
            <v-tab
              v-for="item in tabs"
              :key="item._id"
              @click="_cbSelectTab(item._id)"
              :ref="`tab-${item._id}`">
              {{ translateUI(item.cod, lang) }}
            </v-tab>
          </v-tabs>

          <div style="display: flex; justify-items: space-between">
            <v-text-field
              v-model="search"
              prepend-inner-icon="mdi-magnify"
              :label="translateUI('Header_6', lang)"
              single-line
              hide-details
              clearable
              solo flat
              style="flex-grow: 3"
              class="pt-0 ob-client-search">
            </v-text-field>

            <v-text-field
              v-model.number="perPage"
              type="number"
              max="50"
              min="1"
              prepend-inner-icon="mdi-page-previous-outline"
              single-line
              hide-details
              solo flat
              style="flex-grow: 1"
              class="pt-0 ob-client-search">
            </v-text-field>
          </div>

          <v-pagination
            circle
            v-model="page"
            :length="totalPages"
            v-if="totalPages"
            class="ob-client-pagination"
          ></v-pagination>
          <v-alert
            :value="true"
            type="warning"
            class="ob-no-records"
            v-else>
            {{ translateUI('NoRecords', lang) }}
          </v-alert>

          <!-- <v-progress-linear :indeterminate="true" height="2" v-show="loading"></v-progress-linear> -->
        </div>

        <v-container fluid grid-list-md>
          <v-layout row wrap>
            <v-flex v-for="cifItem in items" :key="cifItem.cif_op + cifItem.cif_os" xs12 sm12 md6 lg4 xl3>
              <v-card>
                <!-- <v-img
                  :src="`http://lorempixel.com/400/200/city/?${cifItem.cif_op + cifItem.cif_os}`"
                  height="200px">
                  <v-container fill-height fluid pa-0>
                    <v-layout fill-height justify-end>
                      <v-btn icon color="white" small @click="_cbToggleFav(cifItem)">
                        <v-icon color="red" small>{{cifItem.fav ? 'mdi-heart' : 'mdi-heart-outline'}}</v-icon>
                      </v-btn>
                    </v-layout>
                  </v-container>
                </v-img> -->

                <v-card-title primary-title class="pt-2" style="justify-content: center">
                  <div style="min-width: 0; text-align: center">
                    <div class="headline" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                      <v-btn icon color="white" small @click="_cbToggleFav(cifItem)">
                        <v-icon color="red" small>{{cifItem.fav ? 'mdi-star' : 'mdi-star-outline'}}</v-icon>
                      </v-btn>
                      <span class="primary--text">{{cifItem.denumire_apl}}</span>
                    </div>
                    <div class="grey--text">{{translate('tip_apl', cifItem.tip_apl)}}</div>
                    <div class="grey--text">{{cifItem.judet}}</div>
                  </div>
                </v-card-title>

                <!-- <v-divider></v-divider> -->

                <v-card-text class="py-0 px-1">
                  <v-list dense>
                    <v-subheader>
                      <span>{{ translateUI('Card_4', lang) }}</span>
                    </v-subheader>
                    <v-list-tile v-for="head in headers" :key="head">
                      <v-list-tile-content>
                        <v-list-tile-title>{{translate(head, null)}}</v-list-tile-title>
                        <v-list-tile-sub-title>{{formatProperty(head, cifItem[head])}}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>

                  <v-list dense three-line style="max-width: 100%" class="reports-list-client">
                    <v-subheader @click="cifItem.reportsOpen = !cifItem.reportsOpen" style="cursor: pointer">
                      <span>{{ translateUI('Card_8', lang) }} ({{getNoOfReportsPerItem(cifItem.reports)}})</span>
                      <v-spacer></v-spacer>
                      <v-icon small color="grey">{{cifItem.reportsOpen ? 'mdi-menu-up' : 'mdi-menu-down'}}</v-icon>
                    </v-subheader>
                    <template v-if="cifItem.reports && cifItem.reports.length && cifItem.reportsOpen">
                      <v-list-group
                        v-for="(reportsArray, reportId) in getReportsCollection(cifItem)"
                        :key="reportId"
                        :prepend-icon="Array.isArray(reportsArray) && reportsArray.length && reportsArray[0].public ? 'mdi-parking' : 'mdi-file-multiple'"
                        append-icon="mdi-menu-down"
                        no-action>
                        <!-- :value="cifItem.reportsOpen"> -->
                        <template v-slot:activator>
                          <v-list-tile>
                            <v-list-tile-content>
                              <v-list-tile-title>{{ translateUI(reportsArray[0].denumire, lang) }}</v-list-tile-title>
                              <v-list-tile-sub-title>{{ translateUI(reportsArray[0].detalii, lang) }}</v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </template>

                        <v-list-tile
                          v-for="(report, reportIndex) in reportsArray"
                          :key="reportId + '_' + reportIndex"
                          @click="dummy">
                          <v-list-tile-action>
                            <v-checkbox
                              v-model="cifItem.selectedReports"
                              :value="report"
                              color="accent"
                              hide-details>
                            </v-checkbox>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-title @click="toggleReport(cifItem, report)">
                              <!-- {{ report.denumire }}  -->
                              {{ report.perioada.replace('T', translateUI('TrimScurt_1' ,lang)) }}
                              <template v-if="user.admin">
                                <span class="grey--text">{{ report.data | shortDate }} {{ report.time }}</span>
                              </template>
                            </v-list-tile-title>
                          </v-list-tile-content>
                          <!-- <v-list-tile-action>
                            <v-btn icon flat @click="_cbDownloadReport(report)" color="primary">
                              <v-icon>mdi-package-down</v-icon>
                            </v-btn>
                          </v-list-tile-action> -->
                        </v-list-tile>
                      </v-list-group>
                    </template>
                    <v-list-tile class="download-reports" v-if="cifItem.reports && cifItem.reports.length && cifItem.reportsOpen">
                      <v-list-tile-content>
                        <v-btn :disabled="!cifItem.selectedReports.length" block color="primary" flat @click="_cbDownloadReports(cifItem)">
                          <template v-if="cifItem.selectedReports.length">
                            {{ translateUI('Card_10', lang)}} ({{cifItem.selectedReports.length}})
                          </template>
                          <template v-else>
                            0 {{ translateUI('Card_9', lang) }}
                          </template>
                          <v-icon right>
                            mdi-package-down
                          </v-icon>
                        </v-btn>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import translate from '@/mixins/Translate';
import streamSaver from 'streamsaver';

export default {
  name: 'client-section',
  components: {},
  mixins: [translate],
  props: {
    type: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    }
  },
  data: () => ({
    tabsUpdate: 1,
    selectedTabIdentifier: null
  }),
  computed: {
    host () {
      return this.$store.getters.host
    },
    tabs () {
      return this.$store.getters[`${this.type}/tabs`]
    },
    items () {
      return this.$store.getters[`${this.type}/items`]
    },
    headers () {
      if (this.items.length) {
        return Object.keys(this.items[0]).filter(key => {
          if (this.user.admin) {
            return ['cif_op', 'cif_os', 'capita'].includes(key)
          } else {
            return ['cif_op', 'cif_os', 'capita'].includes(key)
          }
        })
      } else return []
    },
    search: {
      get () {
        return this.$store.getters[`${this.type}/search`]
      },
      set (value) {
        this.$store.dispatch(`${this.type}/search`, value)
      }
    },
    pagination () {
      return this.$store.getters[`${this.type}/pagination`]
    },
    perPage: {
      get () {
        return this.pagination.rowsPerPage
      },
      set (value) {
        const v = parseInt(value)
        if (!isNaN(v) && v > 0 && v <= 50) this.$store.dispatch(`${this.type}/setPerPage`, v)
        else this.$store.dispatch(`${this.type}/setPerPage`, 10)
      }
    },
    total () {
      return this.$store.getters[`${this.type}/total`]
    },
    totalPages () {
      if (this.total) return Math.ceil(this.total / this.pagination.rowsPerPage)
      return 0
    },
    page: {
      get () {
        return this.pagination.page
      },
      set (value) {
        const pagination = { ...this.pagination }
        pagination.page = value
        this.$store.dispatch(`${this.type}/paginationChanged`, pagination)
      }
    },
    loading () {
      return this.$store.getters[`${this.type}/loading`]
    },
    token () {
      return this.$store.getters['token']
    },
    user () {
      return this.$store.getters['user']
    },
    lang () {
      return this.$store.getters['dictionar/lang']
    },
    languages () {
      return this.$store.getters['dictionar/languages']
    }
  },
  watch: {
    lang (v) {
      this.items.forEach((item, index) => {
        this.$set(this.items[index], 'selectedReports', [])
      })
    }
  },
  methods: {
    getNoOfReportsPerItem (reports) {
      return reports.reduce((agg, rep) => {
        if (rep.v.lang === this.lang) agg++
        return agg
      }, 0)
    },
    getReportsCollection (item) {
      const reports = {}

      item.reports.forEach(rep => {
        if (rep.k.endsWith(`_${this.lang}`) && (rep.v.vizibil || this.user.admin)) {
          if (reports[rep.k]) {
            reports[rep.k].push(rep.v)
          } else {
            reports[rep.k] = [rep.v]
          }
        }
      })

      Object.keys(reports).forEach(rep => {
        reports[rep].sort((a, b) => a.perioada.localeCompare(b.perioada) * -1)
      })

      return reports
    },
    _cbDownloadReports (cifItem) {
      this.$store.commit(`${this.type}/setLoading`, true)
      // const fileStream = createWriteStream(report.zip)
      if (this.host !== 'http://localhost:3333' && this.host !== 'http://http://10.194.250.173') {
        streamSaver.mitm = `${this.host}/mitm.html`
      }
      const fileStream = streamSaver.createWriteStream(`TUDs_Analytics_${cifItem.cif_op}_${cifItem.cif_op}_${cifItem.selectedReports.length}_${cifItem.selectedReports.length > 1 ? this.translate('raport', 'Rapoarte') : this.translate('raport', 'Raport')}.zip`)
      fetch(`${this.host}/smb-raport`, {
        method: 'post',
        headers: new Headers({
          'Content-Type': 'application/json',
          'Authorization': this.token
        }),
        body: JSON.stringify({ reports: cifItem.selectedReports, cifop: cifItem.cif_op, cifos: cifItem.cif_os })
      })
        .then(res => {
          this.$store.commit(`${this.type}/setLoading`, false)

          // more optimized
          if (res.body.pipeTo) {
            return res.body.pipeTo(fileStream).then(() => console.log('done writing'))
          }

          const writer = fileStream.getWriter()
          const reader = res.body.getReader()
          const pump = () => reader.read().then(({ value, done }) => {
            if (done) {
              // close the stream so we stop writing
              writer.close()
              this.$store.commit(`${this.type}/setLoading`, false)
            } else {
              // Write one chunk, then get the next one
              writer.write(value).then(pump)
            }
          })

          // Start the reader
          pump().then(() => {
            this.$store.commit(`${this.type}/setLoading`, false)
            console.log('Closed the stream, Done writing')
          })
        })
        .catch(err => {
          this.error = true
          this.$store.commit(`${this.type}/setLoading`, false)
          console.log(err)
        })
    },
    _cbSelectTab (id) {
      this.$store.dispatch(`${this.type}/setSelectedTab`, id)
    },
    _cbToggleFav (item) {
      this.$store.dispatch(`users/toggleFavoriteCif`, { cif_op: item.cif_op, cif_os: item.cif_os, type: this.type })
    },

    translate (head, value) {
      switch (head) {
        case 'cif_op': return this.translateUI('Card_5', this.lang)
        case 'cif_os': return this.translateUI('Card_6', this.lang)
        case 'capita': return this.translateUI('Card_7', this.lang)
        case 'tip_apl': {
          switch (value) {
            case 'Judet': return this.translateUI('Card_1', this.lang)
            case 'Municipiu': return this.translateUI('Card_2', this.lang)
            case 'Oras': return this.translateUI('Card_3', this.lang)
          }
          break
        }
        case 'raport': return this.translateUI(value === 'Raport' ? 'Raport' : 'Rapoarte', this.lang)
      }
    },
    formatProperty (head, value) {
      switch (head) {
        case 'cif_op': return value
        case 'cif_os': return value
        case 'capita': return Number(value).toLocaleString()
      }
    },

    toggleReport (cifItem, report) {
      const index = cifItem.selectedReports.findIndex(r => r === report)
      if (index > -1) {
        cifItem.selectedReports.splice(index, 1)
      } else {
        cifItem.selectedReports.push(report)
      }
    },
    dummy () {}
  },
  created () {
    // this.$store.dispatch(`${this.type}/setEventWatchers`)
    // this.$store.dispatch(`${this.type}/fetchItems`)
  }
}
</script>

<style>

</style>
